import React, { useState, useEffect } from 'react';
import { formatDateTime2Lines } from '../libs/utils';
import { toast } from 'react-toastify';
import { Text, TextOnly } from '../components/Text';
import ReactTable from '../components/ReactTable';
import { Header } from '../components/Header';
import { Loading } from '../components/Loading';
import { oemAdminGetTokenList } from '../libs/db-lib';

const TokenAuth: React.FC<any> = (props) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [tokens, setTokens] = useState<any[]>([]);
  const [filterString, setFilterString] = useState<string>('');

  useEffect(() => {
    const onMount = async () => {
      await getShopTokens();
      setIsLoading(false);
    }
    onMount();
  }, []);

  const getShopTokens = async () => {
    const response = await oemAdminGetTokenList();
    if (!response?.error) {
      (response.tokenList ?? []).forEach((token: any) => {
        const filterObj = { ...token };
        // filterObj.addedBy = userDisplayName(token.addedBy, currentShop.shopUsers);
        filterObj.addedOn = `${formatDateTime2Lines(token.addedOn).date} ${formatDateTime2Lines(token.addedOn).time}`;
        token.filterValue = Object.values(filterObj)
          .join(' ')
          .toLocaleLowerCase();
      });
      setTokens(response.tokenList);
    } else {
      toast.error(`${TextOnly('error')}: ${response.error}`, {
        containerId: 'standard',
      });
    }
  };

  const tokenTableCols = [
    {
      Header: TextOnly('tokenSerialNo'),
      accessor: 'tokenSerial',
    },
    {
      Header: TextOnly("addedBy"),
      accessor: 'addedBy',
      Cell: ({row}: any) => {
        return (
          <span>
            {row.original.addedBy}
          </span>
        );
      },
    },
    {
      Header: TextOnly("addedOn"),
      accessor: 'addedOn',
      Cell: ({row}: any) => {
        const dateObj = formatDateTime2Lines(row.original.addedOn);
        return (
          <div>
            <span>{dateObj.date}</span>
            <br />
            <span>{dateObj.time}</span>
          </div>
        );
      },
    },
  ];

  console.log("tokens", tokens);
  console.log("columns", tokenTableCols);
  return (
    <div className="u-padding-bottom">
      <Header title="TokenAuth" />
      {isLoading ? (
        <Loading />
      ) : (
        <div className="c-box--white u-padding-none">
          <div className="l-container u-margin-none">
            <div className="u-width-100-percent u-margin-top-large display-flex">
              <div className="c-field u-margin-bottom-large">
                <label htmlFor="search" className="c-field__label u-is-vishidden">
                  <Text tid="searchTokens" />...
                </label>
                <input
                  type="text"
                  id="search"
                  maxLength={50}
                  className="c-input"
                  placeholder={TextOnly('searchTokens') + '...'}
                  value={filterString}
                  onChange={(event) => setFilterString(event.target.value)}
                />
                <i className="c-field__input-icon fal fa-search" />
              </div>
            </div>
            <ReactTable
              tableName={'TokenAuth'}
              columns={tokenTableCols}
              data={tokens} 
              globalFilter={filterString} 
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default TokenAuth;